/**
 * A CSS hex colour — `#abc` or `#aabbcc`. Nothing else is accepted, because these values come from
 * app config rows an operator types by hand and are handed straight to a CSS custom property: a
 * value CSS cannot parse leaves the property set but meaningless, which reads as a broken tile
 * rather than as an unset one.
 */
const HEX_COLOUR = /^#([0-9A-Fa-f]{3}){1,2}$/;

export const isValidHexColour = (colour?: string | null): boolean => !!colour && HEX_COLOUR.test(colour);

/**
 * The colour when it is a usable hex value, otherwise undefined.
 *
 * Undefined rather than a default, so the consumer can leave its CSS custom property unset and let
 * the stylesheet's own fallback stand — see `begin-booking-icon-tile` in `default-home.scss`. React
 * omits an undefined style value, so the property is genuinely absent.
 */
export const configuredHexColour = (colour?: string | null): string | undefined =>
	isValidHexColour(colour) ? (colour as string) : undefined;
